<div class="critval" *ngIf="showItem">
  <label>{{criteriaName}}</label>
  <div class="value">
    <span *ngFor="let critval of criteriaValues | keyvalue">
      {{critval.value}}
    </span>
  </div>
</div>
